import { PropsWithChildren, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const RedirectComponent = ({
	from,
	to,
	children,
}: PropsWithChildren<{
	from: string[];
	to: string;
}>) => {
	const nav = useNavigate();
	useEffect(() => {
		if (from?.includes(location.pathname)) {
			nav(to);
		}
	}, [to]);
	return <>{children}</>;
};
